import DeviceCart from "./DeviceCart/DeviceCart";
import OrderRequest from "./OrderRequest";
import OrderItemCard from "./OrderItemCard";
import ProductDetailComponents from './ProductDetail/components/index.tsx';
import HeroSection from "./heroSection/heroSection";
import ProductCard from "./ProductCard";
import GenericAllCategories from "./genericAllCategories/genericAllCategories";
import CategoryList from "./categoryList/categoryList";
import ActivityList from "./ActivityList";
import OrderDetailsComponents from "./OrderRequestDetail";
import EyeBrow from "./eyeBrow/eyeBrow";
import Typography from "./Typography";
import MarketPlaceBreadCrumbs from "./MarketplaceBreadCrumbs/MarketPlaceBreadCrumbs";
import { Button, IconButton } from './ButtonComponents'
import Dialog from "./Dialog";
import Drawer from "./Drawer";

const marketplaceComponents = {
  MarketPlaceBreadCrumbs,
  Typography,
  DeviceCart,
  OrderRequest,
  ProductDetailComponents,
  ProductCard,
  HeroSection,
  GenericAllCategories,
  OrderItemCard,
  CategoryList,
  ActivityList,
  OrderDetailsComponents,
  Button,
  IconButton,
  EyeBrow,
  Dialog,
  Drawer,
};

export default marketplaceComponents;
